import { Heading, Stack } from '@chakra-ui/react'

import type { IconProps } from '@/components/UI/Icon/Icon'
import IconBullets, { type IconBulletItem } from '@/components/UI/IconBullets'

export default function WhatYoullDo({
  title,
  titleSize = 'lg',
  iconProps,
  bullets,
}: {
  title?: string
  titleSize?: 'lg' | 'xl' | undefined
  iconProps: Pick<IconProps, 'backgroundColor' | 'color' | 'size'>
  bullets: IconBulletItem[]
}) {
  return (
    <Stack spacing={`${titleSize === 'xl' ? 12 : 8}px`}>
      <Heading size={titleSize}>{title ?? "What you'll do"}</Heading>
      <IconBullets
        iconProps={iconProps}
        bullets={bullets.map(({ key, icon, body }) => ({
          key,
          icon,
          body,
        }))}
      />
    </Stack>
  )
}
